export class MenuModel {

  constructor(
    public title: string,
    public opcion1: string,
    public opcion2: string,
    public opcion3: string
  ) {}


}


export class CerrarModel{
  constructor(
    public btn :string

  ){}
}
export class Fechas {
  constructor(
    public consulta ,
    public nacimiento
  ){}
}

export class HeaderModel{

  constructor(
      public titleHeader: string
  ){}

}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/